import {
  createAbsence,
  createValeur,
  updateAbsence,
  updateValeur,
} from "../../../api/social";
import { showToastError, showToastSuccess } from "../../../services/toast";
import { useSocialStore } from "../../../stores/social";
import { useTranslation } from "react-i18next";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../../ui/modals/ModalShell";

const Overlap = ({ createOrEdit, idEmployee, id, closeModal }: any) => {
  const { t } = useTranslation();
  const {
    isOverlap,
    setIsOverlap,
    tabElements,
    formDataDetails,
    setUpdateSocial,
    updateSocial,
    setFormDataDetails,
  } = useSocialStore();

  const handleSubmit = (e: any) => {
    e.preventDefault();

    // creation d'une valeur
    if (tabElements === "Valeurs" && createOrEdit === "create") {
      const dataToSend = {
        ...formDataDetails,
        amount: parseInt(formDataDetails.amount),
      };

      createValeur(idEmployee, dataToSend)
        .then(() => {
          showToastSuccess(t("Valeur créée avec succès"));
          setUpdateSocial(!updateSocial);
          setFormDataDetails({});
          setIsOverlap(false);
          closeModal();
        })
        .catch(() => {
          showToastError(t("Erreur lors de la création de la valeur"));
        });
    } else if (tabElements === "Absences" && createOrEdit === "create") {
      // creation d'une absence
      const dataToSend = {
        ...formDataDetails,
        morning: formDataDetails.morning ? true : false,
        afternoon: formDataDetails.afternoon ? true : false,
      };

      createAbsence(idEmployee, dataToSend)
        .then(() => {
          showToastSuccess(t("Absence créée avec succès"));
          setUpdateSocial(!updateSocial);
          setFormDataDetails({});
          setIsOverlap(false);
          closeModal();
        })
        .catch(() => {
          showToastError(t("Erreur lors de la création de l'absence"));
        });
    } else if (tabElements === "Absences" && createOrEdit === "edit") {
      // modification d'une absence
      const dataToSend = {
        ...formDataDetails,
        morning: formDataDetails.morning ? true : false,
        afternoon: formDataDetails.afternoon ? true : false,
      };

      updateAbsence(Number(id), dataToSend)
        .then(() => {
          showToastSuccess(t("Absence modifiée avec succès"));
          setUpdateSocial(!updateSocial);
          setFormDataDetails({});
          setIsOverlap(false);
          closeModal();
        })
        .catch(() => {
          showToastError(t("Erreur lors de la modifications de l'absence"));
        });
    } else if (tabElements === "Valeurs" && createOrEdit === "edit") {
      // modification d'une valeur
      const dataToSend = {
        ...formDataDetails,
        amount: parseInt(formDataDetails.amount),
      };
      updateValeur(Number(id), dataToSend)
        .then(() => {
          showToastSuccess(t("Valeur modifiée avec succès"));
          setUpdateSocial(!updateSocial);
          setIsOverlap(false);
          setFormDataDetails({});
          closeModal();
        })
        .catch(() => {
          showToastError(t("Erreur lors de la modification de la valeur"));
        });
    }
  };

  return (
    isOverlap && (
      <ModalShell
        title={t("ATTENTION")}
        size="sm"
        onClose={() => setIsOverlap(false)}
        footer={
          <>
            <ModalButton
              variant="secondary"
              onClick={() => setIsOverlap(false)}
            >
              {t("Annuler")}
            </ModalButton>
            <ModalButton variant="primary" onClick={(e) => handleSubmit(e)}>
              {t("Valider")}
            </ModalButton>
          </>
        }
      >
        <ModalConfirmText>
          {t("Il y a un chevauchement de date, êtes vous sur de vouloir continuer ?")}
        </ModalConfirmText>
      </ModalShell>
    )
  );
};

export default Overlap;
